<script lang="ts">
  import { cn } from '@shared/utils';

  export let src: string;
  // export let width = 1000;
  // export let height = 1000;

  export let wrapClasses = '';
</script>

<div
  class="{cn(
    'skeleton after:bg-skeleton-gradient dark:bg-alt-dark bg-default-100 dark:after:bg-skeleton-gradient-dark relative flex items-center justify-center overflow-hidden after:absolute after:inset-0 after:-translate-x-full',
    wrapClasses,
  )}"
>
  <img {src} alt="placeholder" class="h-full w-full object-contain" />
</div>

<style lang="scss">
  .skeleton {
    &::after {
      animation: shimmer infinite 5s;
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }
</style>
